export default "__VITE_ASSET__BtBpSULj__"